module.exports = "/images/icon-onboarding-heart.svg?36ef5473cc94d735bb498122317f3462";